<a [href]="downloadUrl" class="download" target="_blank">
  <div class="logo">
    <img src="/assets/images/menubar_tada_logo@4x.png">
  </div>
  <div class="right">
    앱 설치하기
    <img src="/assets/images/btn_gotolink@4x.png">
  </div>
</a>
